import { makeAuthPlugin as makeApiAuthPlugin } from '@/api'
import { makeAuthPlugin as makeBotAuthPlugin } from '@/bot'

const apiAuth = makeApiAuthPlugin({ userService: 'users', namespace: 'apiAuth' })
const botAuth = makeBotAuthPlugin({ userService: 'users', namespace: 'botAuth' })

export { apiAuth, botAuth }